var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.colors),function(item,index){return _c('div',{key:`${index}-${item.color}`,staticClass:"block",style:({ background: item.color })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }